import React from "react";
import { CgLogIn } from 'react-icons/cg';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import moment from 'moment';

export default function ShowFollowUpModal(props) {

  let { showFollowUpModal, handleHideFollowUpModal, followUpItems, followUpTotal, offset } = props;

  console.log("followUpItemsfollowUpItemsfollowUpItems", followUpItems);

  return (


    <div className={showFollowUpModal ? "fixed w-full lg:left-24 left-0 h-full inset-0 z-40 overflow-hidden mt-0 flex justify-center items-center overflow-y-auto bg-black/40 md:p-0 p-1" : "hidden"} style={{ marginTop: '0rem', }}  >
      <div className="animate__animated animate__fadeInDown animate__faster bg-[#f8f8fb] md:w-[46rem] w-full mx-auto rounded shadow-lg overflow-y-auto mt-2">
        <div className="flex items-center justify-between p-6 py-2 bg-blue-500 border-b">
          <p className="text-[16px] font-medium text-white uppercase">Follow Up List</p>
          <div className="rounded-full cursor-pointer modal-close ">
            <svg onClick={() => handleHideFollowUpModal()} className="fill-current text-white/60 hover:text-white/100 " xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18">
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z">
              </path>
            </svg>
          </div>
        </div>


        <div className="max-w-full overflow-x-auto">
          <div className="inline-block min-w-full ">
            <div className="overflow-x-auto">
              <table className="min-w-full border-0 divide-y ">
                <thead className="bg-gray-200 rounded-t">
                  <tr className="text-sm font-semibold text-left text-gray-500 uppercase">
                    <th className="px-6 py-3 whitespace-nowrap">#</th>
                    <th className="px-6 py-3 whitespace-nowrap">UserName</th>
                    <th className="px-6 py-3 whitespace-nowrap">Comment</th>
                    <th className="px-6 py-3 whitespace-nowrap">Reminder Date</th>
                    <th className="px-6 py-3 whitespace-nowrap">Follow Up Date</th>
                  </tr>
                </thead>
                <tbody>
                  {followUpItems && followUpItems.length > 0 ?
                    followUpItems.map((element, index) => (<React.Fragment key={element.id}>
                      <tr key={element.id} className="bg-white border-b border-black border-opacity-10 text-sm text-gray-600">
                        <td className="px-6 py-3 whitespace-nowrap font-medium">{offset + index + 1}</td>
                        <td className="px-6 py-3 whitespace-nowrap">{element && element.userId && element.userId.userName ? element.userId.userName : "-"}</td>
                        <td className="relative w-full px-6 py-3">
                          {/* {element && element.comment.substring(0, 20) ? element.comment.substring(0, 20) + "..." : element.comment} */}
                          <div class="targetablepx-4 tooltip px-6 py-3 cursor-pointer w-full">
                            <span className='top-0 left-0 p-6 mx-auto -mt-4 text-sm text-black bg-gray-200 rounded tooltip-text'>
                              {element && element.comment ? element.comment : ""}</span>
                            {element && element.comment.substring(0, 20) ? element.comment.substring(0, 20) + "..." : element.comment}
                          </div>
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap">{moment(new Date(parseInt(element.reminderDate))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm")}</td>
                        <td className="px-6 py-3 whitespace-nowrap">{moment(new Date(parseInt(element.createdAt))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm")}</td>
                      </tr>
                    </React.Fragment>))
                    : (<tr className="bg-white bg-opacity-5 " >
                      <td className="col-span-3 px-6 py-3 text-sm font-medium text-gray-500 whitespace-nowrap">Not Found</td>
                    </tr>)
                  }
                </tbody>

              </table>
            </div>
          </div>
        </div>


      </div >
    </div >

  );
}
